export default {"src":"/_next/static/media/play-circle.6b6f2b0f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};